
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M454.487 302.934c0 2.196-.641 4.099-2.246 5.703-1.608 1.602-3.511 2.406-5.71 2.406H40.639c-2.197 0-4.101-.805-5.708-2.406-1.605-1.61-2.409-3.507-2.409-5.703V90.086c0-2.197.801-4.098 2.409-5.704 1.607-1.603 3.511-2.408 5.708-2.408h268.037c5.243-11.741 12.023-23.197 20.092-33.002H41.077c-11.162 0-20.714 4.527-28.667 12.469C4.462 69.385.49 78.93.49 90.085V368.02c0 11.156 3.972 21.132 11.92 29.074 7.953 7.942 17.505 11.917 28.667 11.917h139.709c0 6.417-1.355 12.583-4.061 19.34-2.705 6.761-5.411 24.398-8.117 29.467-2.703 5.071-4.057 8.787-4.057 11.151 0 4.394 1.605 8.201 4.82 11.406 3.212 3.215 7.018 4.822 11.415 4.822h129.881c4.396 0 8.204-1.607 11.414-4.822 3.217-3.205 4.822-7.013 4.822-11.406 0-2.194-1.359-5.87-4.063-11.023-2.705-5.153-5.411-22.88-8.114-29.719-2.706-6.846-4.06-12.963-4.06-19.216h135.871c11.158 0 20.709-3.975 28.656-11.917 7.952-7.942 12.301-17.918 12.301-29.074v-92.457c-10.309 3.896-21.719 6.636-33.008 8.051v19.32zM394.498 88.093c0-20.823 16.141-37.763 36.395-37.763S467.5 67.27 467.5 88.093v19.889h21.986V88.093c0-33.088-26.39-60.154-58.594-60.154-32.178 0-58.405 27.065-58.405 60.154v19.889h22.011V88.093zm106.617 25.906H360.456c-5.958 0-10.848 5.006-10.848 11.108v110.771c0 6.111 4.89 11.126 10.848 11.126h140.659c5.933 0 11.374-5.015 11.374-11.126V125.107c0-6.103-5.441-11.108-11.374-11.108z"}})])
          )
        }
      }
    